(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .controller('AdministrationController', AdministrationControllerFn);

    /* controlle for main administration */
    AdministrationControllerFn.$inject = ['$scope'];

    function AdministrationControllerFn($scope) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            App.initAjax(); // initialize core components
        });

        activate();

        /* activation work */
        function activate() { }
    }
})();
